import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export interface DeleteConfirmationData {
	count: number;
	controlledCount: number;
	foreignCount: number;
	currentUser: string;
}

@Component({
	standalone: true,
	imports: [CommonModule, FormsModule],
	selector: 'bp-delete-confirmation',
	template: `
		<div class="modal-header bg-danger text-white">
			<h5 class="modal-title">Löschen bestätigen</h5>
			<button type="button" class="btn-close btn-close-white" aria-label="Schließen" (click)="activeModal.dismiss()"></button>
		</div>
		<div class="modal-body">
			<p>
				<strong>{{ data.count }} {{ data.count === 1 ? 'Punkt' : 'Punkte' }}</strong> werden unwiderruflich gelöscht.
			</p>

			<!-- Warnung bei kontrollierten Punkten -->
			<div *ngIf="data.controlledCount > 0" class="alert alert-warning">
				<strong>Achtung:</strong> {{ data.controlledCount }} {{ data.controlledCount === 1 ? 'Punkt ist' : 'Punkte sind' }}
				bereits <strong>kontrolliert/abgeschlossen</strong>.
			</div>

			<!-- Hinweis bei fremden Punkten -->
			<div *ngIf="data.foreignCount > 0" class="alert alert-info">
				<strong>Hinweis:</strong> {{ data.foreignCount }} {{ data.foreignCount === 1 ? 'Punkt wurde' : 'Punkte wurden' }}
				von einem <strong>anderen Kartierer</strong> erstellt.
			</div>

			<!-- Bei mehr als 5 Punkten: Anzahl eintippen -->
			<div *ngIf="data.count > 5" class="mt-3">
				<label class="form-label">
					Zur Bestätigung bitte die Anzahl <strong>{{ data.count }}</strong> eintippen:
				</label>
				<input type="text"
					class="form-control"
					[(ngModel)]="confirmInput"
					[class.is-invalid]="confirmInput && confirmInput !== data.count.toString()"
					[class.is-valid]="confirmInput === data.count.toString()"
					placeholder="Anzahl eingeben"
					autofocus>
				<div class="form-text">Diese zusätzliche Bestätigung schützt vor versehentlichem Löschen.</div>
			</div>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Abbrechen</button>
			<button type="button"
				class="btn btn-danger"
				[disabled]="!canConfirm()"
				(click)="activeModal.close(true)">
				{{ data.count }} {{ data.count === 1 ? 'Punkt' : 'Punkte' }} löschen
			</button>
		</div>
	`,
	styles: [`
		.alert {
			margin-bottom: 0.5rem;
		}
		.alert:last-of-type {
			margin-bottom: 0;
		}
	`]
})
export class DeleteConfirmationComponent {
	@Input() data!: DeleteConfirmationData;
	confirmInput = '';

	constructor(public activeModal: NgbActiveModal) {}

	canConfirm(): boolean {
		// Bei <= 5 Punkten: immer bestätigbar
		if (this.data.count <= 5) return true;
		// Bei > 5 Punkten: Anzahl muss korrekt eingetippt werden
		return this.confirmInput === this.data.count.toString();
	}
}
